module.exports = __webpack_public_path__ + "static/logo-adhi-karya-77636bcd53fbd9c2573aca0afef9d7e3.png";